<InactivityModal />
<div class="container-fluid h-100">
  <div class="row h-100 ">
    <div class="col-auto bg-white h-100">
      <Sidebar ref="sidebar"></Sidebar>
    </div>
    <div class="col bg-white h-100 m-0">
      <Navbar @toggle-sidebar="toggleSidebar"></Navbar>
      <div class="bg-gray px-4 py-1 h-100 scroll-container">
        <div class="card bg-white shadow-sm mt-3 rounded-5 border-0">
          <div class="d-flex justify-content-start align-items-center mt-3 mb-2 ms-3">
        <router-link :to="'/create_form'">
          <button class="btn btn-warning text-white text-xs rounded-5 shadow-lg fw-500  mb-2">
            <i class="bi bi-arrow-left"></i> Back
          </button>
        </router-link>
      </div>
          <div class="card-header bg-white rounded-5 border-0">
            <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
              <li class="nav-item" role="presentation">
                <button class="nav-link" :class="{active: activeTab === 'sections'}"
                  @click="activeTab = 'sections'">
                  Sections
                </button>
              </li>
              <li class="nav-item" role="presentation">
                <button class="nav-link" :class="{active: activeTab === 'preview'}"
                  @click="activeTab = 'preview'">
                  Preview Application Form
                </button>
              </li>
            </ul>
          </div>

          <div v-show="activeTab === 'preview'">
            <FormView/>
          </div>

          <div class="card-body tab-content" id="sectionTabsContent">
            <div v-show="activeTab === 'sections'">
              <div class="card border-0 p-1 rounded-5">
                <div class="d-flex justify-content-end align-items-center">
                  <button class="btn btn-warning text-white text-xs rounded-5 shadow-lg fw-500" data-bs-toggle="modal"
                    data-bs-target="#create_section">
                    <i class='bx bx-plus'></i> Create Section
                  </button>
                </div>
              </div>
              <table id="questionsTable" class="table table-striped text-xs mt-3">
                <thead class="bg-dark text-white">
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Section Name</th>
                    <th scope="col">Locked</th>
                    <th scope="col">Actions</th>
                  </tr>
                </thead>
                <tbody class="text-black">
                  <tr v-for="(section, index) in sections" :key="section.id" class="border-section">
                    <th scope="row">{{ index + 1 }}</th>
                    <td>{{ section.name }}</td>
                    <td>
                      <span v-if="section.is_locked" class="badge bg-danger text-white">Locked</span>
                      <span v-else class="badge bg-success text-white">Unlocked</span>
                    </td>
                    <td>
                      <router-link :to="'/assign_questions/'+section.id">
                        <button class="btn btn-primary text-xxs rounded-5 mx-1 btn-sm shadow"><i class="bi bi-eye"></i>
                          Assign Questions</button>
                      </router-link>
                      <button 
                        class="btn btn-primary text-xxs rounded-5 mx-1 btn-sm shadow"
                        data-bs-toggle="modal"
                        :data-bs-target="'#edit_section_' + section.id"
                        @click="editSectionName(section)"
                      >
                        <i class="bi bi-pencil-square"></i> Edit
                      </button>
                      <button @click="deleteSection(section.id)"
                        class="btn btn-danger text-xxs rounded-5 mx-1 btn-sm shadow">
                        <i class="bi bi-trash"></i> Delete
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <!-- Create Section Modal -->
        <div class="modal fade" id="create_section" tabindex="-1" aria-labelledby="create_sectionModalLabel"
          aria-hidden="true">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <p class="modal-title text-xs fw-500" id="exampleModalLabel">Create Section</p>
                <button type="button" class="btn-close text-xs fw-500" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <form @submit.prevent="createSection">
                <div class="modal-body">
                  <div class="mb-3">
                    <label for="section_name" class="form-label text-xs fw-500">Section Name <span
                        class="text-danger">*</span></label>
                    <input type="text" class="form-control rounded-5 text-xs" id="section_name"
                      placeholder="Enter section name" v-model="section_name">
                    <p v-if="errors.section_name" class="text-danger text-xs mt-1">{{ errors.section_name }}</p>
                  </div>
                  <div class="mb-3">
                    <label class="form-label text-xs fw-500">Lock section</label>
                    <div class="form-check form-switch ms-3 mt-1">
                      <input class="form-check-input" type="checkbox" id="locked_toggle" v-model="is_locked">
                      <label class="form-check-label text-xs" for="locked_toggle">
                        {{ is_locked ? 'Locked' : 'Unlocked' }}
                      </label>
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button type="submit" class="btn btn-primary text-xs rounded-5">Post</button>
                </div>
              </form>
            </div>
          </div>
        </div>
        <!-- Edit Section Modal -->
        <div v-for="section in sections" :key="section.id" >
          <div 
            class="modal fade" 
            :id="'edit_section_' + section.id" 
            tabindex="-1" 
            aria-labelledby="edit_sectionModalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog modal-lg">
              <div class="modal-content">
                <div class="modal-header">
                  <p class="modal-title text-xs fw-500">Edit Section</p>
                  <button 
                    type="button" 
                    class="btn-close text-xs fw-500" 
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <div class="modal-body">
                  <div class="mb-3">
                    <label class="form-label text-xs fw-500">
                      Section Name <span class="text-danger">*</span>
                    </label>
                    <input 
                      type="text" 
                      class="form-control rounded-5 text-xs" 
                      v-model="edit_section"
                      placeholder="Enter section name"
                    >
                  </div>
                </div>
                <div class="modal-footer">
                  <button @click="editSection(section)" type="submit" class="btn btn-primary text-xs rounded-5">Post
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- End Edit Section Modal -->
      </div>
    </div>
  </div>
</div>